/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";
import Layout from "../../../../components/layout/Layout";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";
import { Alert, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { GrEdit } from "react-icons/gr";
import { getTimeSheetData } from "../../../../redux/auth/authSlice";
import { RiSendPlaneFill } from "react-icons/ri";
import { BsSendPlusFill } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import { MdDelete } from "react-icons/md";
import {
  HourlyWages,
  otherCost,
  ExpenditureAccordingToTheAttachedPDF,
  costPerDayArticle,
  costPerMonthArticle,
  costAgreementArticle,
  costPerWeekArticle,
} from "../Articles";
import { InvoiceInfoModal } from "./InvoiceInfoModal";
import { SendInvoiceModal } from "./SendInvoiceModal";
import { FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import { convertHouseworkType, mobileScroll } from "common/FunctionUtils";
import { ARTICLE_NUMBERS, LOCALES } from "common/constants";

const PreliminaryInvoices = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");

  const [activePagination, setactivePagination] = useState(1);
  const [totalCount, setTotalCount] = useState();
  const pageCount = 5;

  const [loading, setLoading] = useState(false);
  const [preliminaryInvoices, setPreliminaryInvoices] = useState([]);
  const [show, setShow] = useState({
    id: null,
    data: [],
    ShowInvoiceInfo: false,
  });
  const [sendInvoice, setSendInvoice] = useState();
  const [resendMail, setResendMail] = useState();

  const [getErrorMessages, setgetErrorMessages] = useState(null);
  const formattedText = getErrorMessages?.split(/,\s*\*\s*|\*\s*/);

  const dispatch = useDispatch();

  const articlesNo = {
    HourlyWages: "92",
    otherCost: "93",
    ExpenditureAccordingToTheAttachedPDF: "2",
    costPerDay: "94",
    costPerWeek: "95",
    costPerMonth: "96",
    costAgreement: "97",
  };

  const getPreliminaryInvoices = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `/invoice/all-approval-invoices?PageNumber=${activePagination}&PageSize=${pageCount}`
      );
      setPreliminaryInvoices(res.data.response);
      setTotalCount(res.data.totalCount);
    } catch (err) {
      setPreliminaryInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPreliminaryInvoices();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [activePagination]);

  let items = [];
  let paginationNumber = totalCount / pageCount;
  for (let number = 1; number <= Math.round(paginationNumber); number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === activePagination}
        onClick={() => {
          setactivePagination(number);
        }}
      >
        {number}
      </Pagination.Item>
    );
  }

  const handlePreviewInvoiceInfo = async (id, send) => {
    try {
      setLoading(true);
      const URL = `/invoice/get-approval-invoice/${id}`;

      const result = await axios.get(URL);
      if (result.status === 200) {
        const fetchPreliminaryInvoices = result?.data?.response;

        if (send) {
          setSendInvoice((prevState) => ({
            ...prevState,
            show: true,
            fetchPreliminaryInvoices,
          }));
          setLoading(false);
        } else {
          const {
            vat,
            amount,
            isFixed,
            customer,
            showDates,
            description,
            invoiceApprovalFreelancers,
            invoiceApprovalWorkingHours,
              holidaySavings,
          holidaySavingsFee,
          pension,
          pensionAmount,
          } = fetchPreliminaryInvoices;

          const filteredWorkingHours = invoiceApprovalWorkingHours?.filter(
            (item) => {
              return (
                item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_TAX_FREE &&
                item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_WITH_TAX &&
                item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE &&
                item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX &&
                item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY &&
                item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY &&
                item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY &&
                item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY &&
                item?.articleNumber !== ARTICLE_NUMBERS.TRAVEL &&
                item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE &&
                item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX &&
                item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF
              );
            }
          );

          const freelancer =
            invoiceApprovalFreelancers?.length > 0
              ? invoiceApprovalFreelancers.map((item) => ({
                  amount: item.amount,
                  userId: item.userId,
                  signUpUser: item.freelancerDetails,
                  pensionAmount: item.pensionAmount,
                  pension: item.pension,
                   holidaySavings: item.holidaySavings,
              holidaySavingsFee: item.holidaySavingsFee,
                }))
              : [];

          let invoiceHours = [];

          if (freelancer && freelancer.length !== 0) {
            freelancer.forEach((freelancers) => {
              let array = [];
              filteredWorkingHours.forEach((item) => {
                const {
                  amountPerUnit,
                  number,
                  articleNumber,
                  workingDate,
                  userId,
                  houseworkType,
                  dateId,
                  id
                } = item;

                // Check if userId is present in freelancers.userId array
                if (userId === freelancers?.userId) {
                  array = [
                    {
                      ...array[0],
                      [dateId ? dateId : workingDate.split("T")[0]]: {
                        units: number,
                        amount: amountPerUnit,
                        houseworkType: {
                          value: houseworkType,
                          name: convertHouseworkType(houseworkType),
                           id: id,
                        },
                        article:
                          articleNumber === articlesNo.HourlyWages
                            ? HourlyWages
                            : articleNumber === articlesNo.otherCost
                            ? otherCost
                            : articleNumber === articlesNo.costPerDay
                            ? costPerDayArticle
                            : articleNumber === articlesNo.costPerWeek
                            ? costPerWeekArticle
                            : articleNumber === articlesNo.costPerMonth
                            ? costPerMonthArticle
                            : articleNumber === articlesNo.costAgreement
                            ? costAgreementArticle
                            : articleNumber ===
                              articlesNo.ExpenditureAccordingToTheAttachedPDF
                            ? ExpenditureAccordingToTheAttachedPDF
                            : "",
                      },
                    },
                  ];
                }
              });
              invoiceHours.push(...array);
            });
          } else {
            let array = [];
            filteredWorkingHours.forEach((item) => {
              const {
                amountPerUnit,
                number,
                articleNumber,
                workingDate,
                houseworkType,
                dateId,
                id, 
                userId
                
              } = item;
              array = [
                {
                  ...array[0],
                  [dateId ? dateId : workingDate.split("T")[0]]: {
                    units: number,
                    amount: amountPerUnit,
                    houseworkType: {
                      value: houseworkType,
                      name: convertHouseworkType(houseworkType),
                      id: id,
                  userId: userId,
                    },
                    article:
                      articleNumber === articlesNo.HourlyWages
                        ? HourlyWages
                        : articleNumber === articlesNo.otherCost
                        ? otherCost
                        : articleNumber === articlesNo.costPerDay
                        ? costPerDayArticle
                        : articleNumber === articlesNo.costPerWeek
                        ? costPerWeekArticle
                        : articleNumber === articlesNo.costPerMonth
                        ? costPerMonthArticle
                        : articleNumber === articlesNo.costAgreement
                        ? costAgreementArticle
                        : articleNumber ===
                          articlesNo.ExpenditureAccordingToTheAttachedPDF
                        ? ExpenditureAccordingToTheAttachedPDF
                        : "",
                  },
                },
              ];
            });
            invoiceHours.push(...array);
          }
          const invoiceFile = Array(freelancer.length).fill([]);
          // const element = invoiceHours.splice(invoiceHours.length - 1, 1)[0];
          // invoiceHours.splice(0, 0, element);
          // freelancer?.splice(freelancer.length - 1, 1);

          const otherArticles = invoiceApprovalWorkingHours?.filter((item) => {
            return (
              item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_TAX_FREE ||
              item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_WITH_TAX ||
              item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE ||
              item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX ||
              item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY ||
              item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY ||
              item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY ||
              item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY ||
              item?.articleNumber === ARTICLE_NUMBERS.TRAVEL ||
              item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE ||
              item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX ||
              item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF 
            );
          })
        .map((item) => {
          if (item.foodAllowance && item.totalDayOfTravels) {
            return {
              ...item,
              foodAllowance: item.foodAllowance / item.totalDayOfTravels
            };
          }
          return item;
        });;

          const selectedData = {
            selectedCustomer: customer,
            description,
            freelancer,
            invoiceHours,
            showDates,
            id,
            vat,
            isFixed,
            amount,
            invoiceFile,
            fetchPreliminaryInvoices,
            otherArticles,
          holidaySavings,
          holidaySavingsFee,
          pension,
          pensionAmount,
          };
          setLoading(false);
          dispatch(getTimeSheetData(selectedData));

          setShow((prevState) => ({
            ...prevState,
            ShowInvoiceInfo: true,
            data: {
              ...fetchPreliminaryInvoices,
            },
          }));
        }
      } else {
        setLoading(false);
        toast.error(t("Something went wrong please try again."));
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleDeletePreliminaryInvoice = async (preId) => {
    try {
      setLoading(true);
      const result = await axios.delete(`/invoice/preliminary-invoice-delete/${preId}`);
      if (result.status === 200) {
        toast.success(t("Preliminary invoice deleted successfully"));
        getPreliminaryInvoices(); // Refresh the list
      } else {
        toast.error(t("Something went wrong please try again."));
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || t("Failed to delete preliminary invoice"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    mobileScroll();
  }, []);

  return (
    <Layout
      className="create_invoices mt-5 margin-top-767 invoice_pgs_nws space"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/preliminary-invoices"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/preliminara-fakturor"
          />
        )}
      </Helmet>
      {loading && <Loader />}

      <div className="invoice_wrapper">
        <div className="mt-5 m-auto w-50">
          {getErrorMessages && (
            <div className="position-relative">
              <Alert variant="danger">
                {formattedText?.map((text, idx) => {
                  if (text.includes("UserId") && text.includes("UserName")) {
                    const translatedText = text
                      .replace("UserId", t("UserId"))
                      .replace("UserName", t("UserName"));
                    return (
                      <p
                        key={idx}
                        style={{
                          color: "black",
                          fontSize: "medium",
                          lineHeight: "15px",
                        }}
                      >
                        {translatedText}
                      </p>
                    );
                  }
                  return (
                    <p
                      key={idx}
                      style={{
                        color: "black",
                        fontSize: "medium",
                        lineHeight: "15px",
                      }}
                    >
                      {t(text)}
                    </p>
                  );
                })}
              </Alert>
              <RxCross2
                onClick={() => setgetErrorMessages(null)}
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: 0,
                  right: 0,
                  color: "black",
                  fontSize: "18px",
                }}
              />
            </div>
          )}
        </div>

        <h4 className="accident_ins font-weight-bold">
          {t("Preliminary Invoices")}
        </h4>
        <p className="mb-0 note-validate-text">
          <h6>
            {" "}
            {t(
              "Note: The preliminary invoices you have created will be deleted automatically after"
            )}{" "}
            45 {t("days from the date of creation.")}
          </h6>
        </p>
      </div>

      <div className="table-div table-responsive table-section1 ">
        <Table className="table table-striped">
          <thead>
            <tr>
              <th className="invoice_tabeletext">{t("Invoice No")}</th>
              <th className="invoice_tabeletext" style={{ width: 165 }}>
                {t("Customer")}
              </th>
              <th className="invoice_tabeletext">{t("Created")}</th>
              <th className="invoice_tabeletext">{t("Amount")}</th>
              <th className="invoice_tabeletext">{t("Status")}</th>
              <th className="invoice_tabeletext">{t("Type")}</th>
              <th className="invoice_tabeletext">{t("Action")}</th>
            </tr>
          </thead>

          <tbody>
            {preliminaryInvoices?.map((data) => {
              return (
                <tr key={data?.id}>
                  <td>{data?.id}</td>
                  <td>{data?.customer?.name}</td>
                  <td>{data?.createdDate?.slice(0, 10)}</td>
                  <td>{data?.amount}</td>
                  <td>
                    {data?.isManually
                      ? "N/A"
                      : (() => {
                          switch (data?.customerApproved) {
                            case null:
                              return t("Pending");
                            case true:
                              return t("Approved");
                            case false:
                              return t("Unapproved");
                            default:
                              return "";
                          }
                        })()}
                  </td>

                  <td>
                    {data?.isManually
                      ? t("Manual Preliminary Invoices")
                      : t("Automated Preliminary Invoices")}
                  </td>

                  <td>
                    {!data?.isManually ? (
                      data?.isInvoiceSent === true ? (
                        <Button
                          id="top"
                          className="outlines-primary mt-2  color-bg"
                          disabled={true}
                        >
                          <FaCheck color="white" />
                        </Button>
                      ) : data?.customerApproved === false ||
                        data?.customerApproved === true ? (
                        <div>
                          {data.customerApproved === false ? (
                            <div className="preliminary-btns">
                            <Button
                              id="top"
                              data-toggle="tooltip"
                              data-placement="top"
                              title={t("Edit")}
                              className="outlines-primary mt-2  color-bg  "
                              onClick={() => handlePreviewInvoiceInfo(data.id)}
                            >
                              <GrEdit className="cursor-pointer" />
                            </Button>
                             <button
                                id="top"
                                data-toggle="tooltip"
                                data-placement="top"
                                title={t("Delete")}
                                className="outlines-primary color-bg"
                                onClick={() => handleDeletePreliminaryInvoice(data.id)}
                              >
                                <MdDelete
                                  color="white"
                                  size={22}
                                />
                              </button>
                            </div>
                          ) : (
                            <div className="preliminary-btns">
                              <button
                                id="top"
                                data-toggle="tooltip"
                                data-placement="top"
                                title={t("Edit")}
                                className="outlines-primary color-bg"
                                onClick={() =>
                                  handlePreviewInvoiceInfo(data.id)
                                }
                              >
                                <GrEdit className="cursor-pointer" size={22} />
                              </button>
                              <Button
                                id="top"
                                data-toggle="tooltip"
                                data-placement="top"
                                title={t("Create Invoice")}
                                className="outlines-primary mt-2  color-bg"
                                onClick={() =>
                                  handlePreviewInvoiceInfo(data?.id, false)
                                }
                              >
                                <RiSendPlaneFill
                                  color="white"
                                  style={{ margin: "2px 7px 1px 6px" }}
                                />
                              </Button>
                              <button
                                id="top"
                                data-toggle="tooltip"
                                data-placement="top"
                                title={t("Delete")}
                                className="outlines-primary color-bg"
                                onClick={() => handleDeletePreliminaryInvoice(data.id)}
                              >
                                <MdDelete
                                  color="white"
                                  size={22}
                                />
                              </button>
                            </div>
                          )}
                        </div>
                      ) : (
                        data?.customerApproved === null && (
                          <div className="preliminary-btns">
                            <button
                              id="top"
                              data-toggle="tooltip"
                              data-placement="top"
                              title={t("Edit")}
                              className="outlines-primary color-bg"
                              onClick={() => handlePreviewInvoiceInfo(data.id)}
                            >
                              <GrEdit className="cursor-pointer" size={22} />
                            </button>
                            <button
                              id="top"
                              data-toggle="tooltip"
                              data-placement="top"
                              title={t("Resend email")}
                              className="outlines-primary color-bg "
                              onClick={() =>
                                setResendMail((prevState) => ({
                                  ...prevState,
                                  show: true,
                                  data,
                                }))
                              }
                            >
                              <BsSendPlusFill
                                color="white"
                                style={{ margin: "0" }}
                              />
                            </button>
                            <button
                              id="top"
                              data-toggle="tooltip"
                              data-placement="top"
                              title={t("Delete")}
                              className="outlines-primary color-bg"
                              onClick={() => handleDeletePreliminaryInvoice(data.id)}
                            >
                              <MdDelete
                                color="white"
                                size={22}
                              />
                            </button>
                          </div>
                        )
                      )
                    ) : data?.isInvoiceSent === true ? (
                      <Button
                        id="top"
                        className="outlines-primary color-bg"
                        disabled={true}
                      >
                        <FaCheck color="white" />
                      </Button>
                    ) : (
                      <div className="preliminary-btns">
                      <Button
                        id="top"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={t("Edit")}
                        className="outlines-primary mt-2  color-bg  "
                        onClick={() => handlePreviewInvoiceInfo(data.id)}
                      >
                        <GrEdit className="cursor-pointer" size={22} />
                      </Button>
                       <button
                                id="top"
                                data-toggle="tooltip"
                                data-placement="top"
                                title={t("Delete")}
                                className="outlines-primary color-bg"
                                onClick={() => handleDeletePreliminaryInvoice(data.id)}
                              >
                                <MdDelete
                                  color="white"
                                  size={22}
                                />
                              </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      <div className="paginationInvoice">
        <Pagination>{items}</Pagination>
        <br />
      </div>

      {show.ShowInvoiceInfo && (
        <InvoiceInfoModal show={show} setShow={setShow} />
      )}

      {(sendInvoice?.show || resendMail?.show) && (
        <SendInvoiceModal
          sendInvoice={sendInvoice}
          setSendInvoice={setSendInvoice}
          getPreliminaryInvoices={getPreliminaryInvoices}
          resendMail={resendMail}
          setResendMail={setResendMail}
          setgetErrorMessages={setgetErrorMessages}
        />
      )}
    </Layout>
  );
};

export default PreliminaryInvoices;
